// LO QUE SABEN LAS PANTALLAS DE TERMINALES · T-1
//
// VIVE FUERA DEL COMPONENTE por la misma razón que `ui/calidad.js`: son
// datos y no dibujo, los usan dos pantallas (Terminales y, cuando
// llegue, la terminal virtual del Anexo B), y así se pueden probar sin
// pintar nada.

// LOS MODOS, DICHOS CON UN VERBO. «CONSUMO» es lo que guarda la base;
// quien elige en la pantalla lee «Gastar». Un desplegable de códigos en
// mayúsculas obliga a saberse el sistema antes de poder usarlo.
//
// La tercera columna es la frase que se pinta debajo del desplegable:
// ayuda en el lugar, sin mandar a nadie a un manual.
export const MODOS = [
  ['VITRINA', 'Solo mirar', 'Enseña lo que hay en la repisa y no mueve nada. Es como nace toda terminal.'],
  ['CONTEO', 'Contar', 'Conteo a ciegas: pide contar sin enseñar cuánto debería haber.'],
  ['CONSUMO', 'Gastar', 'Un apretón descuenta una pieza del producto en pantalla.'],
  ['RECHAZO', 'Rechazar', 'Un apretón apunta una pieza mala y pregunta por qué.'],
  ['REABASTO', 'Reponer', 'Un apretón suma lo que acaba de llegar a la repisa.'],
  ['PRODUCCION', 'Producir', 'Cuenta piezas buenas. Es el denominador del PPM.'],
];

export function nombreDelModo(codigo) {
  return (MODOS.find((m) => m[0] === codigo) || ['', codigo])[1];
}

export function explicacionDelModo(codigo) {
  return (MODOS.find((m) => m[0] === codigo) || [])[2] || '';
}
